import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";

export default createPaginatedList({
  listId: "outboundOrders",
  fetch: api.outboundOrders.search
});



// WEBPACK FOOTER //
// ./app/modules/Shipping/pagination.js